import React from "react";

export default function UndoneCircle({ id, style }) {
    return <svg id={id} width="100" height="100" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg" style={{stroke: '#E23645', ...style}}>
    <path d="M35 61.25C49.4975 61.25 61.25 49.4975 61.25 35C61.25 20.5025 49.4975 8.75 35 8.75C20.5025 8.75 8.75 20.5025 8.75 35C8.75 49.4975 20.5025 61.25 35 61.25Z" stroke-width="4.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M43 27.5L27 42.5" stroke-width="4.2" stroke-linecap="round"/>
    <path d="M42.5 43L27.5 27" stroke-width="4.2" stroke-linecap="round"/>
    </svg>;
}


// WEBPACK FOOTER //
// ./src/rifa/components/layout/icons/undoneCircle.jsx